import classnames from 'classnames';
import { Avatar } from '@/components/UI/Avatar';
import { getNameInitials } from '@/helpers/utils';
import './index.scss';

export const GroupedAvatars = ({
  data = [],
  count,
  size = 34,
  limit = 3,
  showCounter,
  onCounterClick,
  className,
}) => {
  const totalCount = count || data.length || 0;
  const sliceCount =
    (showCounter && totalCount > showCounter && limit - 1) || limit;

  return (
    <div
      className={classnames('grouped-avatars', className)}
      style={{ height: `${size}px` }}
    >
      {data.length
        ? data
            .slice(0, sliceCount)
            .map((item, index) => (
              <Avatar
                key={`${item.id}${index}`}
                image={item.image}
                src={item.src}
                alt={item.alt}
                nameInitials={
                  item.nameInitials ||
                  (item.first_name &&
                    getNameInitials(item.first_name, item.last_name)) ||
                  (item.full_name &&
                    getNameInitials(
                      item.full_name?.split(' ')[0],
                      item.full_name?.split(' ')[1],
                    ))
                }
                size={size}
              />
            ))
        : new Array(limit)
            .fill('-')
            .map((item, idx) => <Avatar key={idx} size={size} />)}
      {showCounter && totalCount > showCounter && (
        <div
          className="grouped-avatars__counter f-18 f-500"
          style={{ width: size, height: size }}
          onClick={onCounterClick}
        >
          +{totalCount - (limit - 1)}
        </div>
      )}
    </div>
  );
};
